import styles from './style.module.scss';
interface HeadingWithImageFillProps {
  backgroundImageSrc: string;
  title: string;
  description: string;
  testId: string;
}

export default function HeadingWithImageFill({ backgroundImageSrc, title, description, testId }: HeadingWithImageFillProps) {

  return (
    <div data-testid={testId}>
      <h1 className={styles.title} style={{ backgroundImage: `url("${backgroundImageSrc}")` }}>{title}</h1>
      <div className={styles.description} dangerouslySetInnerHTML={{ __html: description }}/>
    </div>
  );
}

